import React from "react";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";

export default function Footer() {
    return (
        <Grid container spacing={2}>
            <Grid item xs={12}>
                {/*<Typography variant="body2" sx={{*/}
                {/*    fontWeight: 'bold',*/}
                {/*    display: 'center',*/}
                {/*    justifyContent: 'center',*/}
                {/*    alignItems: 'center',*/}
                {/*    mt: 10*/}
                {/*}}>*/}
                {/*    footer.*/}
                {/*</Typography>*/}
            </Grid>
            <Grid item xs={12}>
                <Typography
                    variant="body2"
                    sx={{
                        fontWeight: 'bold',
                        display: 'flex',
                        justifyContent: 'flex-end',
                        alignItems: 'center',
                        flexWrap: 'wrap',
                        gap: 1,
                        m: 2
                    }}
                >
                    <a href="/aboutus" className="plain-link">
                        About Us
                    </a>

                    |

                    <a href="/privacy_policy.html" className="plain-link">
                        Privacy Policy
                    </a>

                    |

                    <a href="/terms_of_use.html" className="plain-link">
                        Terms of Use
                    </a>

                    |

                    <a
                        href="https://skrach.it"
                        className="plain-link"
                    >
                        © 2025 Skrach.it
                    </a>

                    |

                    <a
                        href="https://heteswebes.hu"
                        target="_blank"
                        rel="noopener"
                        className="plain-link"
                    >
                        Designed & Developed by HetesWebes.hu
                    </a>
                </Typography>
            </Grid>
        </Grid>
    );
}
